import * as S from './styles';

declare type DataListItem = {
    label: string;
    value: string;
}

declare type DataListProps = {
    label: string;
    items: DataListItem[];
}

export default function DataList({ label, items }: DataListProps) {
    return (
        <S.Container>
            <S.Label>{label}</S.Label>
            <S.Card>
                {items.map((item, index) => (
                    <S.Row key={index}>
                        <S.RowLabel>{item.label}</S.RowLabel>
                        <S.RowValue>{item.value}</S.RowValue>
                    </S.Row>
                ))}
            </S.Card>
        </S.Container>
    )
}
